import React from "react";
import { HeaderProps } from "../HeaderProps";
import './HeaderDesktop.css'
import { Button } from "@material-ui/core";
import { Route } from 'react-router-dom'
import ConfirmDialog from "../../dialog/ConfirmDialog";
import { AuthService } from "../../../services/authentication/AuthService";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { ReactComponent as NexiLogo } from '../../../resources/images/logoNexi.svg';
import BackIcon from "../../../resources/wrappers/BackIcon";
import { ReactComponent as HelpIcon } from "../../../resources/images/help_thin.svg";
import { ConfigProvider } from "../../../services/configuration/ConfigProvider";
import { MenuTab } from "../../menutab/MenuTab";
import CloseMenuIcon from "../../../resources/wrappers/menu/CloseMenuIcon";
import StateContextProvider from "../../../context/StateContext";

export class HeaderDesktop extends React.Component<HeaderProps, any> {
    private config = ConfigProvider.getInstance().getConfiguration();
    userType: any;
    constructor(props: HeaderProps) {
        super(props);
        this.doLogout = this.doLogout.bind(this);
        this.state = {
            showDialog: false,
            userType: StateContextProvider.getInstance().getProp("scope"),
            specificPath: ''
        }
    }

    private doLogout(history: any) {
        console.log("[Header] do logout called!");
        GoogleTagManagerService.getInstance().pushInteractionEvent('Click', this.props.title !== undefined ? this.props.title : '', 'click', 'logout confermato');
        AuthService.getInstance().logout().subscribe(() => {
            // Nothing to do in onNext
        }, () => {
            // Nothing to do in onError
        }, () => {
            // onComplete go to login page!
            history.replace('/login')
        });
    }

    private showLogoutDialog() {
        GoogleTagManagerService.getInstance().pushInteractionEvent('PopupImpression', this.props.title !== undefined ? this.props.title : '', 'impression', 'conferma logout');
        this.toggleModal();
    }

    private toggleModal = () => {
        this.setState({
            showDialog: !this.state.showDialog
        });
    }

    private goToClosePage(history: any) {
        if (this.props.closePage !== undefined) {
            history.replace('/');
            if (this.props.returnState !== undefined) {
                history.push(this.props.closePage, this.props.returnState);
            } else {
                history.push(this.props.closePage);
            }
        }
    }

    render() {
        // @ts-ignore
        let supportLink = this.config.supportLink;
        return (
            <div className={"main-header"}
                style={this.props.background ? this.props.backgroundImage ? { backgroundImage: 'url(' + this.props.backgroundImage + ')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', boxShadow: 'inset 0 0 0 2000px rgb(0 0 0 / 50%)' } : { background: this.props.background } : { background: 'transparent' }}>
                <div className={this.props.showTitle ? "base-header-plus-height" : "base-header"} style={this.props.hideBorder ? { border: 'none' } : {}}>
                    <div className={"header-button-left-container"}>
                        {this.props.showBack ? (
                            <Route render={({ history }) => {
                                const handleGoBack = () => {
                                    if (this.props.specificPath) {
                                    history.push(this.props.specificPath); // Reindirizza alla rotta specifica
                                    } else {
                                    history.goBack(); // Utilizza il comportamento predefinito se specificPath non è definito
                                    }
                                };
                                return (
                                    <Button id={"left-button-header"} onClick={handleGoBack} disabled={!this.props.showBack} disableRipple>
                                        {this.props.showBackText ? (
                                            <span className={this.props.backTextLightColor ? "textLightColor" : ''}>INDIETRO</span>
                                        ) : (
                                            <BackIcon width={"30px"} height={"30px"}
                                                fill={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"}
                                                stroke={this.props.buttonContentColor ? this.props.buttonContentColor : "#000000"} />
                                        )}

                                    </Button>
                                )
                            }} />
                        ) : <NexiLogo className={"logo-header-image"} />}
                    </div>
                    <div className={this.props.showTitle ? "header-title-container" : "header-tab-container"}>
                        {this.props.showTitle ?
                            <p className={"header-title"}
                                style={this.props.titleTextColor ? { color: this.props.titleTextColor } : {}}>{this.props.title?.toUpperCase()}</p> :
                            // Tab container and content
                            <MenuTab
                                selectedElementIndex={this.props.selectedElement}
                                userType={this.state.userType}
                            />
                        }
                    </div>
                    <div className={"header-button-right-container"}>
                        {this.props.showLogout ?
                            <div className={"header-button-right-content"}>
                                <div className={"header-help-icon-container"}>
                                    <a href={supportLink} className={"header-support-icon-container"}><HelpIcon width={'27px'} height={'27px'} fill={'#000000'} onClick={() => {
                                        GoogleTagManagerService.getInstance().pushInteractionEvent('Click', 'assistenza', 'click', 'icon');
                                    }} /></a>
                                </div>
                                <Button disableRipple={true} id={"right-button-header"} onClick={() => { this.showLogoutDialog() }}>ESCI</Button>
                            </div>
                            : this.props.showClose ? <Route render={({ history }) => {
                                return <div style={{ cursor: 'pointer' }} onClick={() => this.goToClosePage(history)}>
                                    <CloseMenuIcon width={'20px'} height={'20px'} fill={'#000000'} />
                                </div>
                            }}
                            /> : <Button id={"header-right-button-disabled"} disableRipple={true} disabled />}
                    </div>
                </div>
                {this.props.children}
                {
                    this.state.showDialog && <Route render={({ history }) => {
                        return <ConfirmDialog show={this.state.showDialog} onClose={this.toggleModal} title={"Log out"}
                            content={"Vuoi davvero uscire dal portale?"}
                            buttonNoText={"ANNULLA"} buttonYesText={"CONFERMA"} onConfirm={() => { this.doLogout(history) }} />
                    }} />
                }
            </div >
        );
    }
}